<template>
  <div class="i18n-select">
    <el-dropdown
      class="i18n-select__dropdown"
      :show-timeout="150"
      :hide-timeout="100"
      ref="dropdown"
      @command="doChangeLanguage"
      @visible-change="onVisibleChange"
    >
      <div class="i18n-select__trigger">
        <span v-text="currentLanguage.title" />
        <i
          class="i18n-select__trigger__icon icon-chevron-down"
          :class="{ 'i18n-select__trigger__icon--rotated': isDropdownVisible }"
        />
      </div>
      <el-dropdown-menu
        class="i18n-select__menu"
        :visible-arrow="false"
        slot="dropdown"
      >
        <el-dropdown-item
          class="i18n-select__option"
          v-for="language in languages"
          :command="getItemCommand(language.id)"
          :key="language.id"
        >
          <div
            class="i18n-select__option"
            :class="{ 'i18n-select__option--current': language.id === value }"
          >
            <span v-text="language.title" />
            <i
              class="i18n-select__option__icon icon-tick"
            />
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { I18nUtil } from '@shared/i18n-utils/i18n-util';
import { getLanguage, getLanguages, getLanguageCode } from '@shared/i18n';

export default {
  name: 'app-i18n-select',

  data() {
    return {
      value: getLanguageCode(),
      isDropdownVisible: false,
    };
  },

  computed: {
    languages() {
      return getLanguages();
    },
    currentLanguage() {
      return getLanguage(this.value);
    },
    currentFlagUrl() {
      return this.currentLanguage.label ? this.getFlagUrl(this.currentLanguage.label) : null;
    },
  },

  methods: {
    doChangeLanguage(language) {
      if (!language) return;
      I18nUtil.doChangeLanguage(language);
    },
    getFlagUrl(label) {
      return `url("/images/flags/${label}.png")`;
    },
    getItemCommand(id) {
      if (id === this.value) return null;
      return id;
    },
    onVisibleChange(isVisible) {
      this.isDropdownVisible = isVisible
    },
  },
};
</script>

<style scoped>
.i18n-select {
  cursor: pointer;
}

.i18n-select__dropdown {
  height: 100%;
  display: inline-grid;
  align-content: center;
}

.i18n-select__trigger {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 0 8px;

  font-size: 12px;
  font-weight: 400;
  color: #6c6c6c;

  min-width: 104px;
  height: 32px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 2px 6px 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  border-radius: 4px;
}

.i18n-select__trigger__icon {
  transition: transform .3s ease-out;
}

.i18n-select__trigger__icon--rotated {
  transform: rotate(180deg)
}

.i18n-select__menu {
  padding: 8px;
  min-width: 160px;
}

.i18n-select__menu.el-popper {
  margin-top: 10px;
}

.i18n-select__option {
  padding: 0 4px 0 8px;
}

.i18n-select__option.el-dropdown-menu__item:focus,
.i18n-select__option.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #ffffff;
}

.i18n-select__option {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  
  font-size: 14px;
  font-weight: normal;
  letter-spacing: -0.3px;
  line-height: 2;
  color: #494949;
}

.i18n-select__option--current {
  font-weight: bold;
  color: #2acccc;
}

.i18n-select__option__icon {
  display: none;
  color: #2acccc;
  justify-self: end;
  font-size: 18px;
}

.i18n-select__option--current .i18n-select__option__icon {
  display: inline-block;
}

/* .i18n-select__flag {
  position: relative;
  width: 32px;
  height: 32px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 100%;
}

.i18n-select__flag--dropdown-item {
  border: 4px solid transparent;
}

.i18n-select__flag--current::before {
  position: absolute;
  content: '';
  width: 36px;
  height: 36px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #2acccc;
  border-radius: 100%;
} */
</style>
